// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconChef = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M12 17c-.566 0-1.09-.136-1.54-.369l-.92 1.777A5.35 5.35 0 0012 19c.888 0 1.727-.213 2.46-.592l-.92-1.777c-.45.233-.974.369-1.54.369" />,
    <path
      fillRule="evenodd"
      d="M5 11a5 5 0 013.896-8.92A4.98 4.98 0 0112 1a4.98 4.98 0 013.104 1.08Q15.54 2 16 2a5 5 0 013 9v5a7 7 0 11-14 0zm14-4a3 3 0 01-2 2.83V12H7V9.83a3.001 3.001 0 011.54-5.782l.89.161.709-.562A2.98 2.98 0 0112 3c.706 0 1.35.241 1.861.647l.71.562.89-.16A3 3 0 0119 7M7 16v-2h10v2a5 5 0 01-10 0"
    />
  );
export default SvgIconChef;
